export default __webpack_public_path__ + "static/media/publication-active.1f6f8545.svg";